import { render, staticRenderFns } from "./SendEstimateModal.vue?vue&type=template&id=02ddded8&"
import script from "./SendEstimateModal.vue?vue&type=script&lang=js&"
export * from "./SendEstimateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02ddded8')) {
      api.createRecord('02ddded8', component.options)
    } else {
      api.reload('02ddded8', component.options)
    }
    module.hot.accept("./SendEstimateModal.vue?vue&type=template&id=02ddded8&", function () {
      api.rerender('02ddded8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/SendEstimateModal.vue"
export default component.exports